import { createSelector } from '@reduxjs/toolkit';
import { selectGrinders } from '../../quality-grinders/selectors/selectBasicGrinders';

export const selectQualityGrinderOptions = createSelector(selectGrinders, grinders => {
  const sortedGrinders = [...grinders].sort((a, b) => a.name.localeCompare(b.name));
  return [...sortedGrinders];
});
